import { abyssColors } from '@/theme/colors';

export const paginationStyles = {
  '&.MuiTablePagination-root': { borderBottom: 0 },
  '& .MuiTablePagination-toolbar': { p: 0, minHeight: '32px' },
  '& .MuiTablePagination-actions': { m: 0 },
  '& .MuiTablePagination-actions button': { p: 0 },
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    fontSize: '1rem',
  },
  '& .MuiTablePagination-input': {
    fontSize: '1rem',
  },
};
export const rowSx = {
  '&:hover': { backgroundColor: abyssColors.primary[50] },
  '& td': {
    borderRight: `1px solid ${abyssColors.primary[100]}`,
  },
  '& td:last-of-type': {
    borderRight: 'none',
  },
  // subtle divider between rows
  '&:not(:last-child) td': {
    borderBottom: `1px solid ${abyssColors.primary[100]}`,
  },
};

export const cellSx = {
  fontSize: 10,
  fontWeight: 400,
  p: 2,
};
